__turbopack_context__.v({
  "from_franchise": "Ufabga_from_franchise",
  "from_franchise__link": "Ufabga_from_franchise__link",
});
